import {NgModule} from '@angular/core';
import {SharedModule} from '../../../shared/shared.module';
import {PaymentRoutingModule} from './payment-routing.module';

/**
 *  this module will forward the payment request to correspond page.
 * */
@NgModule({
    imports: [
        SharedModule,
        PaymentRoutingModule
    ]
})
export class PaymentModule {
}
